
import { useQuery } from "@tanstack/react-query";
import { handleFetchRequest } from "../../api/requests";
import { Link, useParams } from "react-router-dom";
import { LeftOutlined } from "@ant-design/icons";
import FormRead from "./components/FormRead";

export default function Request() {
  const { id } = useParams();

  const { data: request } = useQuery({
    queryKey: ["requests", id],
    queryFn: () => handleFetchRequest({ _id: id }),
  });



  return (
    <div className="flex flex-col border-b pb-2 mb-2 bg-white">
      <div className="flex justify-between items-center border-b  px-2 py-1 border-t bg-gray-50 text-black">
        <Link
          to={"/change/requests"}
          className="flex items-center justify-center px-2"
        >
          <LeftOutlined /> Back
        </Link>

      </div>


      <div className="">
        <FormRead request={request} />
      </div>
    </div>
  );
}
